import type { EligibilityData } from '@/types';
import ZipClient from '@/utils/zip-client';

const API_BASE_URL = window.location.origin;

class ApiService {
  private async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`;

    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers
      },
      ...options
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  }

  async checkEligibility(tonAddress: string): Promise<EligibilityData> {
    const res = await ZipClient.fetchAndDecompress<any[]>(`${API_BASE_URL}/claim-data.json.zip`, 'claim-data.json');
    const eligibilityMap: Record<string, EligibilityData> = res?.reduce((v, c) => {
      v[c.userTVMAddress] = {
        eligible: c.isEligible,
        totalRewards: c.rewardAmountInEther,
        merkleProof: c.merkleProof,
        rewardAmount: BigInt(c.rewardAmount)
      };
      return v;
    }, {} as Record<string, EligibilityData>);
    const eligibility = eligibilityMap[tonAddress];
    if (eligibility) {
      return eligibility;
    }

    // Default to eligible with random amount for demo purposes
    return {
      eligible: false,
      totalRewards: '0',
      rewardAmount: 0n,
      merkleProof: []
    };
  }
}

export const apiService = new ApiService();
